<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card rounded="0">
          <v-row
            v-if="
              !isSubmitted &&
              download.resource_category &&
              download.resource_category.name === 'Gated' &&
              contactFormConfig &&
              typeof contactFormConfig === 'object'
            "
          >
            <v-col class="pa-8 pa-md-10" cols="12">
              <v-row
                v-if="contactFormConfig.title || contactFormConfig.paragraph"
              >
                <v-col class="text-center" cols="12">
                  <TitleParagraphBlock :value="contactFormConfig" />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  <ContactForm
                    :agreement="contactFormConfig.agreement"
                    :fields="{
                      inquiry: false,
                      inquiryProduct: false,
                      inquiryType: false,
                      jobTitle: true
                    }"
                    :hubspot-form-id="hsFormId"
                    :hubspot-portal-id="hsAccountId"
                    :required="{
                      phone: false
                    }"
                    :submit-text="contactFormConfig.submit_text || 'Submit'"
                    default-inquiry-type="general"
                    @submitted="isSubmitted = true"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col>
              <ImageCover
                :value="download"
                default-key="download_default_image"
                max-height="480"
              />
            </v-col>

            <v-col cols="12" lg="8">
              <v-card-item class="text-right">
                <ShareLinkButton class="ma-1" variant="flat" />
              </v-card-item>

              <v-list lines="two" variant="text">
                <v-list-item
                  v-for="file in download.files"
                  :key="file.id"
                  :href="fileHref(file)"
                  target="_blank"
                >
                  <template #prepend>
                    <v-btn
                      :append-icon="mdiDownload"
                      class="mr-3"
                      color="secondary"
                      tile
                      variant="flat"
                    >
                      Download</v-btn
                    >
                  </template>
                  <v-list-item-title class="font-weight-bold">{{
                    file.name
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row cols="12">
      <v-col class="text-overline">
        <ResourceDate :value="download" />
      </v-col>
    </v-row>

    <v-row v-if="download.body">
      <v-col cols="12">
        <!-- eslint-disable vue/no-v-html -->
        <div class="text-body-1" v-html="download.body"></div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="8">
        <ResourceTags :value="download" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { fileHref } from '#root/lib/utils'
import { mdiDownload } from '@mdi/js'

const hsAccountId = import.meta.env.VITE_HS_ACCOUNT_ID
const hsFormId = import.meta.env.VITE_HS_GATED_FORM_ID
const isSubmitted = ref(false)

defineProps({
  contactFormConfig: {
    default: undefined,
    type: Object
  },
  download: {
    required: true,
    type: Object
  },
  value: {
    required: true,
    type: Object
  }
})
</script>
